import {ListBullets, User, Basket, File} from '@phosphor-icons/react';

export const CplApplicantMenuOptions = (portfoliosList: { id: string }[]) => {
  if (portfoliosList.length > 0) {
    return [
      {
        name: 'Recommendations',
        icon: <ListBullets size={18} color="#212121"/>,
        link: '/cpl-applicant/my-programs'
      },
      {
        name: 'My Applications',
        icon: null,
        options: portfoliosList.map((item: {id: string}, index: number) => ({
          name: `Application ${index + 1}`,
          icon: null,
          link: `/cpl-applicant/${item.id}`
        }))
      }
    ]
  }
  return [
      {
        name: 'My Account',
        icon: <User size={18} color="#212121"/>,
        link: '/cpl-applicant'
      },
      {
        name: 'Recommendations',
        icon: <ListBullets size={18} color="#212121"/>,
        link: '/cpl-applicant/my-programs'
      },
    ]
}

export const CplApplicantMarketplaceMenuOptions = [
  {
    name: 'My Account',
    icon: <User size={18} color="#212121"/>,
    link: '/cpl-applicant'
  },
  {
    name: 'Recommendations',
    icon: <ListBullets size={18} color="#212121"/>,
    link: '/cpl-applicant/my-programs'
  },
  {
    name: 'Marketplace',
    icon: <Basket size={18} color="#212121"/>,
    link: '/cpl-applicant/marketplace'
  },
]

export const CplApplicantOnlyMarketplaceMenuOptions = [
  {
    name: 'My Account',
    icon: <User size={18} color="#212121"/>,
    link: '/cpl-applicant'
  },
  {
    name: 'Marketplace',
    icon: <Basket size={18} color="#212121"/>,
    link: '/cpl-applicant/marketplace'
  },
]

export const UploadDocumentsMenuOption = {
  name: 'File Submission',
  icon: <File size={18} color="#212121"/>,
  link: '/cpl-applicant/evidence-submission'
}